import { AddButton, SlideAction, useSlideLayoutSafe } from '@gripp/shared-ui';
import { useNavigate } from 'react-router-dom';

type ProductNewAlertHeaderActionProps = {
  productId: string;
  routineId: string;
};

export const ProductNewAlertHeaderAction = ({
  productId,
  routineId,
}: ProductNewAlertHeaderActionProps) => {
  const navigate = useNavigate();
  const slideLayout = useSlideLayoutSafe();

  const handlePress = () => {
    const target = `/products/${productId}/alerts/${routineId}/new`;
    if (slideLayout) {
      slideLayout.prepareSlideTransition(SlideAction.NEXT);
      navigate(target, {
        state: { slideLayoutInitialTransition: SlideAction.NEXT },
      });
    } else {
      navigate(target);
    }
  };

  return <AddButton variant="header" onPress={handlePress} />;
};
